import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'BONO 1 — GUÍA DE EMERGENCIA TDAH',
    desc: 'Qué hacer cuando todo se desborda. Protocolo paso a paso para momentos de crisis. 30 módulos. Para cuando ya no sabés qué hacer.',
    value: '$5.000'
  }, {
    num: '02',
    title: 'BONO 2 — CALENDARIO DE RUTINAS VISUALES',
    desc: '30 días de organización para tu hijo. Rutinas matutinas, vespertinas y nocturnas. Sistema de puntos y premios incluido.',
    value: '$4.500'
  }, {
    num: '03',
    title: 'BONO 3 — KIT DE COMUNICACIÓN ESCUELA-HOGAR',
    desc: '5 cartas listas para usar con maestros y directivos. Estrategias de reunión, cuaderno de doble vía y protocolo cuando la escuela no colabora.',
    value: '$4.000'
  }, {
    num: '04',
    title: 'BONO 4 — DIARIO EMOCIONAL DEL NIÑO CON TDAH',
    desc: '18 actividades guiadas para que tu hijo se exprese y regule sus emociones. Para niños de 4 a 14 años.',
    value: '$5.500'
  }, {
    num: '05',
    title: 'BONO 5 — GUÍA DE ALIMENTACIÓN Y TDAH',
    desc: 'Lo que tu hijo come importa más de lo que creés. Alimentos que ayudan, alimentos que empeoran, plan semanal y recetas simples.',
    value: '$4.500'
  }, {
    num: '06',
    title: 'BONO 6 — MAPA DE FORTALEZAS TDAH',
    desc: 'Descubrí los superpoderes de tu hijo. Test de inteligencias múltiples, actividades de autoestima y mapa del tesoro personal.',
    value: '$4.500'
  }];
  return <section className="py-24 px-4 bg-slate-900 border-y border-slate-800" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-amber-500/10 text-amber-400 font-black px-6 py-2 rounded-full mb-6 border border-amber-500/20" data-id="element-20">
            <Gift className="w-5 h-5" data-id="element-21" /> SIEMPRE INCLUIDOS
          </motion.div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-22">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-23">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-950 border border-slate-800 rounded-2xl p-6 relative overflow-hidden group hover:border-amber-500/30 transition-colors" data-id="element-24">
              <div className="absolute top-0 right-0 bg-red-500 text-white font-bold px-4 py-1 rounded-bl-xl text-sm" data-id="element-25">
                <span className="line-through opacity-70 mr-2" data-id="element-26">
                  {bono.value}
                </span>
                GRATIS
              </div>
              <div className="text-5xl font-black text-slate-800/50 mb-4 group-hover:text-amber-500/10 transition-colors" data-id="element-27">
                {bono.num}
              </div>
              <h3 className="text-lg font-bold text-amber-400 mb-3 pr-20" data-id="element-28">
                {bono.title}
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed" data-id="element-29">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}